import { EndpointsOptionsMap } from '../system';
import * as tagsApi from './tags';

export type TagsApiEndpointTypes = EndpointsOptionsMap<typeof tagsApi>;
export { tagsApi };
